export const createStaticTimeFieldsSource = () => {
  return {
    label: 'Select predefined',
    loadOptions: async filter => [
    ],
  };
};

export const createConstStringSource = () => {
  return {
    label: 'constant value',
    loadOptions: async filter => {
      if (filter) {
        return [{
          label: filter,
          key: filter,
          icon: 'text',
        }];
      } else {
        return [{
          isDisabled: true,
          label: 'Start typing...',
          key: 'strart_typing',
          icon: 'text',
        }];
      }
    }
  };
};
